import { render, staticRenderFns } from "./PreviewFile.vue?vue&type=template&id=6caeedc0"
import script from "./PreviewFile.vue?vue&type=script&lang=js"
export * from "./PreviewFile.vue?vue&type=script&lang=js"
import style0 from "./PreviewFile.vue?vue&type=style&index=0&id=6caeedc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports